import { useMemo, useState } from 'react';
import { STORAGE } from '../constants';
import { LocalStorageService } from '../services/local-storage.service';

export const useSession = () => {
  const [session] = useState(LocalStorageService.get(STORAGE.SESSION));
  const [selectedAccount] = useState(LocalStorageService.get(STORAGE.SELECTED_ACCOUNT));
  const [accounts] = useState(LocalStorageService.get(STORAGE.ACCOUNTS));
  const role = useMemo(() => {
    return session?.profile ? session?.profile.toLowerCase() : '';
  }, []);

  return {
    session,
    role,
    selectedAccount,
    accounts
  };
};
